import { useMemo } from 'react'
import { reverse } from 'ramda'
import { Moment } from 'moment'

import moment from 'app/common/lib/momentRange'

/**
 * Массив дней в месяце по дате.
 * Если месяц текущий, то период дней от начала месяца, до текущего дня.
 * Последовательность - от последнего дня до первого
 */

const createDateArray = (date: string): Array<Moment> => {
  const mDate = moment(date, 'YYYY-MM')
  if (!mDate.isValid() || mDate.isAfter(moment(), 'month')) return [] as Array<Moment>

  const mRange = mDate.isSame(moment(), 'month')
    ? mDate.range(mDate.clone(), moment())
    : mDate.range('month')

  return reverse(Array.from(mRange.by('day')))
}

// DEPRECATED
function useMonthDays(date: string, isMoment?: boolean) {
  const res = useMemo(() => {
    const array = createDateArray(date)
    return isMoment ? reverse(array) : reverse(array.map((m) => m.format('DD.MM')))
  }, [date, isMoment])

  return res
}

export function useMonthDaysAsMoment(date: string) {
  const res = useMemo(() => {
    return createDateArray(date)
  }, [date])

  return res
}

export function useMonthDaysAsStrings(date: string) {
  const res = useMemo(() => {
    const moments = createDateArray(date)
    return moments.map((m) => m.format('DD.MM'))
  }, [date])

  return res
}

export default useMonthDays
